import styled from '@emotion/styled'

import { Image } from '@/legacy/components/Image'
import type { MediaProps } from '@/legacy/components/Media'
import { VisuallyHidden } from '@/legacy/components/VisuallyHidden'
import { sanitize } from '@/legacy/core/utils/security'

type PartnerMidia = Omit<MediaProps, 'midia'> & {
  image: MediaProps['image']
}

export interface PartnerItemProps {
  /**
   * Preparação para migração medusa
   */
  midia: PartnerMidia
  link?: string
  width: number
  height: number
}

const PartnerItemStyles = styled.a({
  display: 'flex',
  flex: '0 0 25%',
  alignItems: 'center',
  justifyContent: 'center',
  height: '6.5rem',
  overflow: 'hidden',

  '& .image': {
    width: '100%',
    maxWidth: '7.5rem',
  },
})

const PartnerItem = ({ midia, link, width = 120, height = 80 }: PartnerItemProps) => (
  <PartnerItemStyles as={link ? 'a' : 'span'} href={sanitize(link ?? '')}>
    {midia && midia.image?.url && (
      <>
        {!!link && <VisuallyHidden>{midia.image?.alt}</VisuallyHidden>}
        <div className="image">
          <Image
            data={midia.image}
            width={width}
            height={height}
            alt={midia.image?.alt || 'Logo parceiro'}
            layout="responsive"
            aria-hidden={!!link}
          />
        </div>
      </>
    )}
  </PartnerItemStyles>
)

export default PartnerItem
